module.exports = __webpack_public_path__ + "static/media/secret_plan_header.da92b4ff.svg";